if (document.body.classList.contains("template-product")) {
    const handleNameChange = () => {
        // Select all radio inputs in the group
        const nameInputs = document.querySelectorAll("[name='name1']");
        const targets = document.querySelectorAll(".bcpo-simple.bcpo-text");

        if (!nameInputs.length || !targets.length) return;

        // Helper to toggle visibility based on a specific value
        const updateVisibility = (value) => {
            const isNo = value && value.includes("No");
            const name = document.querySelector("[name='properties[Name]']");
            const number = document.querySelector("[name='properties[Number]']");
            targets.forEach((target) => {
                target.classList.toggle("hidden", isNo);
                if(isNo) {
                    number.removeAttribute('required')
                    name.removeAttribute('required')
                } else {
                    number.setAttribute('required', true)
                    name.setAttribute('required', true)
                }
            });
        };

        // 1. SET INITIAL STATE: Find the currently checked radio button
        const checkedInput = document.querySelector("[name='name1']:checked");
        if (checkedInput) {
            updateVisibility(checkedInput.value);
        }

        // 2. LISTEN FOR CHANGES: Attach listener to EVERY radio in the group
        nameInputs.forEach((radio) => {
            radio.addEventListener("change", (e) => {
                // Only trigger logic if this specific radio is the one being checked
                if (e.target.checked) {
                    updateVisibility(e.target.value);
                }
            });
        });
    };

    const observer = new MutationObserver((mutations, obs) => {
        const selector = document.querySelector(".single-option-selector");
        if (selector) {
            console.log(".single-option-selector loaded");
            handleNameChange();
            obs.disconnect();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}